import {
  SET_APPLEPAY_SESSION_STARTED,
  SET_ORDER_IS_PROCESSING,
  SET_RETURN_HOST_PAYMENT,
  SET_SITE_VALUES,
  SET_WECHAT_PROCESSED,
} from '../actions/action-types';

export const initialState = {
  siteCode: '',
  isPostcodeLookupEnabled: true,
  isShowAutoRenewSubscriptionWarning: false,
  paymentMethodsRequiringContactNumber: [],
  isContactNumberThresholdExceeded: false,
  isApplePaySessionStarted: false,
  orderIsProcessing: false,
  isWechatProcessed: false,
};

const siteReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SITE_VALUES:
      return {...state, ...action.values};
    case SET_RETURN_HOST_PAYMENT:
      return {...state, returnFromHostPayment: true};
    case SET_ORDER_IS_PROCESSING:
      return {...state, orderIsProcessing: action.isProcessing};

    case SET_APPLEPAY_SESSION_STARTED:
      return {...state, isApplePaySessionStarted: action.isStarted};
    case SET_WECHAT_PROCESSED:
      return {...state, isWechatProcessed: action.isProcessed};
    default:
      return state;
  }
};

export default siteReducer;
